var React = require('react');

module.exports = React.createClass({

  render: function() {
    return (
      <div className="second-section container-fluid">
        <div className="row-fluid">
          <div className="privacy-container">
            <h2 className="privacy-title">Terms and conditions of use</h2>
            <ol className="privacyList">
              <li>Introduction
                <ol className="privacyList">
                  <li>These terms and conditions shall govern your use of our website.</li>
                  <li>By using our website, you accept these terms and conditions in full; accordingly, if you disagree with these terms and conditions or any part of these
                    terms and conditions, you must not use our website.</li>
                  <li>If you [register with our website, submit any material to our website or use any of our website services], we will ask you to expressly agree to these
                    terms and conditions.</li>
                  <li>You must be at least [18] years of age to use our website; and by using our website or agreeing to these terms and conditions, you warrant and represent
                    to us that you are at least [18] years of age.</li>
                  <li>Our website uses cookies; by using our website or agreeing to these terms and conditions, you consent to our use of cookies in accordance with the terms
                    of our [privacy and cookies policy].</li>
                </ol>
              </li>
              <li>Copyright notice
                <ol className="privacyList">
                  <li>Subject to the express provisions of these terms and conditions:
                    <ol className="privacyList">
                      <li>we, together with our licensors, own and control all the copyright and other intellectual property rights in our website and the material on our
                        website; and</li>
                      <li>all the copyright and other intellectual property rights in our website and the material on our website are reserved.</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>Licence to use website
                <ol className="privacyList">
                  <li>You may:
                    <ol className="privacyList">
                      <li>view pages from our website in a web browser;</li>
                      <li>download pages from our website for caching in a web browser;</li>
                      <li>print pages from our website;</li>
                      <li>[stream audio and video files from our website; and]</li>
                      <li>[use [our website services] by means of a web browser,]</li>
                    </ol>
                    subject to the other provisions of these terms and conditions.
                  </li>
                  <li>Except as expressly permitted by Section 4.1 or the other provisions of these terms and conditions, you must not download any material from our website
                    or save any such material to your computer.</li>
                  <li>You may only use our website for [your own personal and business purposes], and you must not use our website for any other purposes.</li>
                  <li>Except as expressly permitted by these terms and conditions, you must not edit or otherwise modify any material on our website.</li>
                  <li>Unless you own or control the relevant rights in the material, you must not:
                    <ol className="privacyList">
                      <li>republish material from our website (including republication on another website);</li>
                      <li>sell, rent or sub-license material from our website;</li>
                      <li>show any material from our website in public;</li>
                      <li>exploit material from our website for a commercial purpose; or</li>
                      <li>redistribute material from our website.</li>
                    </ol>
                  </li>
                  <li>Notwithstanding Section 4.5, you may redistribute [our newsletter] in [print and electronic form] to [any person].</li>
                  <li>We reserve the right to restrict access to areas of our website, or indeed our whole website, at our discretion; you must not circumvent or bypass, or
                    attempt to circumvent or bypass, any access restriction measures on our website.</li>
                </ol>
              </li>
              <li>Acceptable use
                <ol className="privacyList">
                  <li>You must not:
                    <ol className="privacyList">
                      <li>use our website in any way or take any action that causes, or may cause, damage to the website or impairment of the performance, availability or
                        accessibility of the website;</li>
                      <li>use our website in any way that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose
                        or activity;</li>
                      <li>use our website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer
                        virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software;</li>
                      <li>conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting)
                        on or in relation to our website without our express written consent;</li>
                      <li>[access or otherwise interact with our website using any robot, spider or other automated means;]</li>
                      <li>[violate the directives set out in the robots.txt file for our website; or]</li>
                      <li>[use data collected from our website for any direct marketing activity (including without limitation email marketing, SMS marketing, telemarketing
                        and direct mailing).]</li>
                    </ol>
                  </li>
                  <li>You must not use data collected from our website to contact individuals, companies or other persons or entities.</li>
                  <li>You must ensure that all the information you supply to us through our website, or in relation to our website, is [true, accurate, current, complete and
                    non-misleading].</li>
                </ol>
              </li>
              <li>Registration and accounts
                <ol className="privacyList">
                  <li>To be eligible for an individual account on our website under this Section 6, you must [be at least 18 years of age and resident in the United Kingdom].</li>
                  <li>You may register for an account with our website by [completing and submitting the account registration form on our website, and clicking on the verification
                    link in the email that the website will send to you].</li>
                  <li>You must not allow any other person to use your account to access the website.</li>
                  <li>You must notify us in writing immediately if you become aware of any unauthorised use of your account.</li>
                  <li>You must not use any other person's account to access the website, [unless you have that person's express permission to do so].</li>
                </ol>
              </li>
              <li>User IDs and passwords
                <ol className="privacyList">
                  <li>If you register for an account with our website, [we will provide you with / you will be asked to choose] a user ID and password.</li>
                  <li>Your user ID must not be liable to mislead and must comply with the content rules set out in Section 10; you must not use your account or user ID for
                    or in connection with the impersonation of any person. </li>
                  <li>You must keep your password confidential.</li>
                  <li>You must notify us in writing immediately if you become aware of any disclosure of your password.</li>
                  <li>You are responsible for any activity on our website arising out of any failure to keep your password confidential, and may be held liable for any losses
                    arising out of such a failure.</li>
                </ol>
              </li>
              <li>Cancellation and suspension of account
                <ol className="privacyList">
                  <li>We may:
                    <ol className="privacyList">
                      <li>[suspend your account;]</li>
                      <li>[cancel your account; and/or]</li>
                      <li>[edit your account details,]</li>
                    </ol>
                    at any time in our sole discretion without notice or explanation.
                  </li>
                  <li>You may cancel your account on our website [using your account control panel on the website].</li>
                </ol>
              </li>
              <li>Your content: licence
                <ol className="privacyList">
                  <li>In these terms and conditions, "your content" means all works and materials (including without limitation text, graphics, images, audio material, video
                    material, audio-visual material, scripts, software and files) that you submit to us or our website for storage or publication on, processing by, or
                    transmission via, our website.</li>
                  <li>You grant to us a [worldwide, irrevocable, non-exclusive, royalty-free licence] to [use, reproduce, store, adapt, publish, translate and distribute your
                    content in any existing or future media / reproduce, store and publish your content on and in relation to this website and any successor website /
                    reproduce, store and, with your specific consent, publish your content on and in relation to this website].</li>
                  <li>You grant to us the right to sub-license the rights licensed under Section 9.2.</li>
                  <li>You grant to us the right to bring an action for infringement of the rights licensed under Section 9.2.</li>
                  <li>You hereby waive all your moral rights in your content to the maximum extent permitted by applicable law; and you warrant and represent that all other
                    moral rights in your content have been waived to the maximum extent permitted by applicable law.</li>
                  <li>You may edit your content to the extent permitted using the editing functionality made available on our website.</li>
                  <li>Without prejudice to our other rights under these terms and conditions, if you breach any provision of these terms and conditions in any way, or if we
                    reasonably suspect that you have breached these terms and conditions in any way, we may delete, unpublish or edit any or all of your content.</li>
                </ol>
              </li>
              <li>Your content: rules
                <ol className="privacyList">
                  <li>You warrant and represent that your content will comply with these terms and conditions.</li>
                  <li>Your content must not be illegal or unlawful, must not infringe any person's legal rights, and must not be capable of giving rise to legal action against
                    any person (in each case in any jurisdiction and under any applicable law).</li>
                  <li>Your content, and the use of your content by us in accordance with these terms and conditions, must not:
                    <ol className="privacyList">
                      <li>be libellous or maliciously false;</li>
                      <li>be obscene or indecent;</li>
                      <li>infringe any copyright, moral right, database right, trade mark right, design right, right in passing off, or other intellectual property right;</li>
                      <li>infringe any right of confidence, right of privacy or right under data protection legislation;</li>
                      <li>constitute negligent advice or contain any negligent statement;</li>
                      <li>constitute an incitement to commit a crime, [instructions for the commission of a crime or the promotion of criminal activity];</li>
                      <li>be in contempt of any court, or in breach of any court order;</li>
                      <li>be in breach of racial or religious hatred or discrimination legislation;</li>
                      <li>be blasphemous;</li>
                      <li>be in breach of official secrets legislation;</li>
                      <li>be in breach of any contractual obligation owed to any person;</li>
                      <li>[depict violence[ in an explicit, graphic or gratuitous manner];]</li>
                      <li>[be pornographic[, lewd, suggestive or sexually explicit];]</li>
                      <li>[be untrue, false, inaccurate or misleading;]</li>
                      <li>[consist of or contain any instructions, advice or other information which may be acted upon and could, if acted upon, cause illness, injury or death,
                        or any other loss or damage;]</li>
                      <li>[constitute spam;]</li>
                      <li>[be offensive, deceptive, fraudulent, threatening, abusive, harassing, anti-social, menacing, hateful, discriminatory or inflammatory; or]</li>
                      <li>[cause annoyance, inconvenience or needless anxiety to any person.]</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>Limited warranties
                <ol className="privacyList">
                  <li>We do not warrant or represent:
                    <ol className="privacyList">
                      <li>the completeness or accuracy of the information published on our website;</li>
                      <li>that the material on the website is up to date; or</li>
                      <li>that the website or any service on the website will remain available.</li>
                    </ol>
                  </li>
                  <li>We reserve the right to discontinue or alter any or all of our website services, and to stop publishing our website, at any time in our sole discretion
                    without notice or explanation; and save to the extent expressly provided otherwise in these terms and conditions, you will not be entitled to any compensation
                    or other payment upon the discontinuance or alteration of any website services, or if we stop publishing the website.</li>
                  <li>To the maximum extent permitted by applicable law and subject to Section 12.1, we exclude all representations and warranties relating to the subject
                    matter of these terms and conditions, our website and the use of our website.</li>
                </ol>
              </li>
              <li>Limitations and exclusions of liability
                <ol className="privacyList">
                  <li>Nothing in a contract under these terms and conditions will:
                    <ol className="privacyList">
                      <li>limit or exclude any liability for death or personal injury resulting from negligence;</li>
                      <li>limit or exclude any liability for fraud or fraudulent misrepresentation;</li>
                      <li>limit any liabilities in any way that is not permitted under applicable law; or</li>
                      <li>exclude any liabilities that may not be excluded under applicable law.</li>
                    </ol>
                  </li>
                  <li>The limitations and exclusions of liability set out in this Section 12 and elsewhere in a contract under these terms and conditions:
                    <ol className="privacyList">
                      <li>are subject to Section 12.1; and</li>
                      <li>govern all liabilities arising under that contract or relating to the subject matter of that contract, including liabilities arising in contract,
                        in tort (including negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in that contract.</li>
                    </ol>
                  </li>
                  <li>To the extent that our website and the information and services on our website are provided free of charge, we will not be liable for any loss or damage
                    of any nature.</li>
                  <li>We will not be liable to you in respect of any losses arising out of any event or events beyond our reasonable control.</li>
                  <li>We will not be liable to you in respect of any business losses, including (without limitation) loss of or damage to profits, income, revenue, use, production,
                    anticipated savings, business, contracts, commercial opportunities or goodwill.</li>
                  <li>We will not be liable to you in respect of any loss or corruption of any data, database or software.</li>
                  <li>We will not be liable to you in respect of any special, indirect or consequential loss or damage.</li>
                  <li>You accept that we have an interest in limiting the personal liability of our officers and employees and, having regard to that interest, you acknowledge
                    that we are a limited liability entity; you agree that you will not bring any claim personally against our officers or employees in respect of any
                    losses you suffer in connection with the website or these terms and conditions (this will not, of course, limit or exclude the liability of the limited
                    liability entity itself for the acts and omissions of our officers and employees).</li>
                </ol>
              </li>
              <li>Breaches of these terms and conditions
                <ol className="privacyList">
                  <li>Without prejudice to our other rights under these terms and conditions, if you breach these terms and conditions in any way, or if we reasonably suspect
                    that you have breached these terms and conditions in any way, we may:
                    <ol className="privacyList">
                      <li>send you one or more formal warnings;</li>
                      <li>temporarily suspend your access to our website;</li>
                      <li>permanently prohibit you from accessing our website;</li>
                      <li>block computers using your IP address from accessing our website;</li>
                      <li>contact any or all of your internet service providers and request that they block your access to our website;</li>
                      <li>commence legal action against you, whether for breach of contract or otherwise; and/or</li>
                      <li>suspend or delete your account on our website.</li>
                    </ol>
                  </li>
                  <li>Where we suspend or prohibit or block your access to our website or a part of our website, you must not take any action to circumvent such suspension
                    or prohibition or blocking (including without limitation creating and/or using a different account).</li>
                </ol>
              </li>
              <li>Variation
                <ol className="privacyList">
                  <li>We may revise these terms and conditions from time to time.</li>
                  <li>[The revised terms and conditions shall apply to the use of our website from the date of publication of the revised terms and conditions on the website,
                    and you hereby waive any right you may otherwise have to be notified of, or to consent to, revisions of these terms and conditions. / We will give
                    you written notice of any revision of these terms and conditions, and the revised terms and conditions will apply to the use of our website from the
                    date that we give you such notice; if you do not agree to the revised terms and conditions, you must stop using our website.]</li>
                  <li>If you have given your express agreement to these terms and conditions, we will ask for your express agreement to any revision of these terms and conditions;
                    and if you do not give your express agreement to the revised terms and conditions within such period as we may specify, we will disable or delete your
                    account on the website, and you must stop using the website.</li>
                </ol>
              </li>
              <li>Assignment
                <ol className="privacyList">
                  <li>You hereby agree that we may assign, transfer, sub-contract or otherwise deal with our rights and/or obligations under these terms and conditions. </li>
                  <li>You may not without our prior written consent assign, transfer, sub-contract or otherwise deal with any of your rights and/or obligations under these
                    terms and conditions. </li>
                </ol>
              </li>
              <li>Severability
                <ol className="privacyList">
                  <li>If a provision of a contract under these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable,
                    the other provisions will continue in effect.</li>
                  <li>If any unlawful and/or unenforceable provision of a contract under these terms and conditions would be lawful or enforceable if part of it were deleted,
                    that part will be deemed to be deleted, and the rest of the provision will continue in effect. </li>
                </ol>
              </li>
              <li>Third party rights
                <ol className="privacyList">
                  <li>A contract under these terms and conditions is for our benefit and your benefit, and is not intended to benefit or be enforceable by any third party.</li>
                  <li>The exercise of the parties' rights under a contract under these terms and conditions is not subject to the consent of any third party.</li>
                </ol>
              </li>
              <li>Entire agreement
                <ol className="privacyList">
                  <li>Subject to Section 12.1, these terms and conditions, together with [our privacy and cookies policy], shall constitute the entire agreement between you
                    and us in relation to your use of our website and shall supersede all previous agreements between you and us in relation to your use of our website.</li>
                </ol>
              </li>
              <li>Law and jurisdiction
                <ol className="privacyList">
                  <li>A contract under these terms and conditions shall be governed by and construed in accordance with [English law].</li>
                  <li>Any disputes relating to a contract under these terms and conditions shall be subject to the [exclusive / non-exclusive] jurisdiction of the courts of
                    [England].</li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
      );
  },
  componentDidMount: function() {
    if (document.querySelector('.main_container') !== null) {
      var navbar_height = document.getElementsByClassName('navbar')[0].offsetHeight;
      var footer = document.getElementsByClassName('folink-footer')[0].offsetHeight;
      var pagecontent = document.getElementsByClassName('main_container')[0].offsetHeight;
      if (pagecontent < window.innerHeight) {
        var container_height = window.innerHeight - footer - navbar_height;
      } else {
        var container_height = pagecontent;
      }
      document.getElementById('content').setAttribute('style', 'height :' + container_height + 'px');
    }

  }
});




// WEBPACK FOOTER //
// ./src/components/Terms.js